import React from "react";
import "./ContactHero.css";

const ContactHero = () => {
  return (
    <section className="oglitz-contact-hero">
      <div className="oglitz-contact-hero-container">
        {/* LEFT CONTENT */}
        <div className="oglitz-contact-hero-content">
          <span className="oglitz-contact-hero-badge">Get in Touch</span>

          <h1>
            Let’s Discuss Your <span>Next Digital Project</span>
          </h1>

          <p>
            Oglitz Software is a technology-driven IT services company
            delivering innovative, secure, and scalable solutions for businesses
            across India and the Middle East. Connect with our team to explore
            how we can help transform your ideas into reliable digital products.
          </p>

          {/* LOCATION LABELS */}
          <div className="oglitz-contact-hero-locations">
            <span className="oglitz-location-pill">🇮🇳 India</span>
            <span className="oglitz-location-pill">🇦🇪 Dubai, UAE</span>
          </div>

          {/* CTA */}
          <div className="oglitz-contact-hero-actions">
            <a href="#contact-form" className="oglitz-contact-primary">
              Start a Conversation
            </a>

            <a
              href="https://wa.me/919532119007"
              target="_blank"
              rel="noopener noreferrer"
              className="oglitz-contact-whatsapp"
            >
              WhatsApp Us
            </a>
          </div>
        </div>

        {/* RIGHT VISUAL */}
        <div className="oglitz-contact-hero-visual">
          <div className="oglitz-contact-hero-glass">
            <h4>Business Hours</h4>
            <p>Monday – Friday</p>
            <span>10:00 AM – 7:00 PM IST</span>

            <div className="oglitz-contact-hero-divider"></div>

            <h4>Email</h4>
            <span>info@oglitz.com</span>

            <h4 className="mt">Phone</h4>
            <span>+91 95321 19007</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
